import React, { useEffect, useState } from 'react'
import moment from "moment"

const Timer = ({record}) => {

  const [waitingTime,setWaitingTime] = useState(0)
  
  useEffect(() => {
    if(record?.waitingTime) {
      const parsedDate = moment(record.waitingTime, 'DD/MM/YYYY HH:mm:s');
      if (parsedDate.isValid()) {
        const now = moment();
        const secondsElapsed = now.diff(parsedDate, 'seconds');
        setWaitingTime(secondsElapsed);
      } else {
        console.error('Invalid waiting time format:', record.waitingTime);
      }
    }
    const time = setInterval(() => {
      setWaitingTime((prevTime) => prevTime + 1);
    },1000)

    return () => {
      clearInterval(time)
    }

  },[record])

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div>
      <strong>
        {formatTime(waitingTime)}
      </strong>
    </div>
  )
}

export default Timer
